import React from 'react'
import { motion } from 'framer-motion'
import { Building2, Users, Settings } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useStats } from '../../hooks/useStats'

const Header = () => {
  const { departments, positions, loading, error } = useStats()

  // Форматирование числа должностей
  const formatPositionsCount = (count) => {
    if (loading) return '...'
    if (error) return '—'
    if (count === 0) return '0'
    if (count < 10) return count.toString()
    return `${count}+`
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-6">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center justify-between"
        >
          {/* Логотип и название */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center justify-center w-16 h-16 bg-white rounded-xl border-2 border-gray-200 overflow-hidden">
              <img 
                src="./images/alp-itsm-logo.png" 
                alt="ALP ITSM Logo" 
                className="w-[130%] h-[130%] object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-8 h-8 bg-blue-500 rounded flex items-center justify-center"><span class="text-white text-sm font-bold">ALP</span></div>';
                }}
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Карьерная Матрица HR
              </h1>
              <p className="text-sm text-gray-500">
                Система карьерных переходов
              </p>
            </div>
          </div>

          {/* Правая часть с статистикой и админкой */}
          <div className="flex items-center space-x-6">
            {/* Статистика */}
            <div className="hidden md:flex items-center space-x-6 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <Users className="w-4 h-4" />
                <span title={loading ? 'Загрузка...' : error ? 'Ошибка загрузки' : `Точное количество: ${departments}`}>
                  {loading ? '...' : error ? '—' : departments} отдел{departments === 1 ? '' : departments < 5 && departments > 1 ? 'а' : 'ов'}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Building2 className="w-4 h-4" />
                <span title={loading ? 'Загрузка...' : error ? 'Ошибка загрузки' : `Точное количество: ${positions}`}>
                  {formatPositionsCount(positions)} должност{positions === 1 ? 'ь' : positions < 5 && positions > 1 ? 'и' : 'ей'}
                </span>
              </div>
            </div>

            {/* Кнопка входа в админку */}
            <Link
              to="/admin/login"
              className="flex items-center space-x-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200"
            >
              <Settings className="w-4 h-4" />
              <span className="hidden sm:inline">Админ-панель</span>
            </Link>
          </div>
        </motion.div>
      </div>
    </header>
  )
}

export default Header 